import PropTypes from "prop-types"
import React from "react"
import { formatDate } from "src/main/Billing/Items/helpers"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

import { formatPaymentData } from "./helpers"

const InvoicesTable = ({ invoices, presentmentCurrency }) => {
  const renderCell = ({ label, value, subtitle }) => (
    <td className="py-4 !text-sm first-of-type:pl-2" aria-label={label}>
      <div>{value}</div>
      {subtitle ? (
        <div className="!text-xs italic !text-gray-600">{subtitle}</div>
      ) : null}
    </td>
  )

  const renderRow = (invoice) => {
    const dueDate = formatDate(invoice.dueDate)
    const source = `${invoice.sourceType} #${invoice.sourceId}`
    const totalAmount = formatCurrencyFromMinorUnits({
      amount: invoice.totalAmount,
      currency: presentmentCurrency,
    })
    const { paymentAmount, paymentSubtitle } = formatPaymentData({
      invoice,
      presentmentCurrency,
    })
    const balanceAmount = formatCurrencyFromMinorUnits({
      amount: invoice.balance,
      currency: presentmentCurrency,
    })

    return (
      <tr key={invoice.id} className="h-12" aria-label={invoice.id}>
        {renderCell({ label: "Due Date", value: dueDate })}
        {renderCell({ label: "Invoice", value: invoice.id, subtitle: source })}
        {renderCell({ label: "Total", value: totalAmount })}
        {renderCell({
          label: "Payment",
          value: paymentAmount,
          subtitle: paymentSubtitle,
        })}
        {renderCell({ label: "Balance", value: balanceAmount })}
      </tr>
    )
  }

  return (
    <div className="w-full" data-testid="print-view-invoices-table">
      <table className="w-full table-auto">
        <thead className="h-8 !bg-gray-200">
          <tr>
            <th className="pl-2">DUE</th>
            <th>INVOICE</th>
            <th>TOTAL</th>
            <th>PAYMENT</th>
            <th>BALANCE</th>
          </tr>
        </thead>
        <tbody className="align-top">{invoices.map(renderRow)}</tbody>
      </table>
    </div>
  )
}

InvoicesTable.propTypes = {
  invoices: PropTypes.array.isRequired,
  presentmentCurrency: PropTypes.string.isRequired,
}

export default InvoicesTable
